import React from 'react'
import styled from 'styled-components'

import Stars from './Stars'
import Name from './Name'
import Canvas from './Canvas'

const Container = styled.div`
  position: fixed;

  width: 100%;
  height: 100%;
`

const Background = () => (
  <Container>
    <Stars />
    <Canvas />
  </Container>
)

export default Background



// WEBPACK FOOTER //
// ./src/components/Background.js